// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ShopTwoToneSvg from "@ant-design/icons-svg/es/asn/ShopTwoTone";
import AntdIcon from '../components/AntdIcon';

var ShopTwoTone = function ShopTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ShopTwoToneSvg
  }));
};

ShopTwoTone.displayName = 'ShopTwoTone';
export default React.forwardRef(ShopTwoTone);